import React from 'react'
import {BaldaPlayer} from '../../components/Game/BaldaPlayer'
import {AppWithMetrika} from '../AppWithMetrika'
import {MINUTE, SECOND} from '../../common'
import {getSettings, globalMuteSound, Settings} from '../../common'

interface Props {
    metrikaId: number
}

interface State {
    lang: string
}

export class YandexWrapper extends React.Component<Props, State> {
    private sdk: any
    private lastShowAdvertTime: number
    private waitTime: number
    private advtCounter: number

    constructor(props: Props) {
        super(props)
        this.state = {lang: 'ru'}
        this.sdk = null
        this.lastShowAdvertTime = Date.now() - 3 * MINUTE
        this.waitTime = 100
        this.advtCounter = 0
        this.init()
    }

    render(): JSX.Element {
        return (
            <>
                <AppWithMetrika
                    player={new BaldaPlayer()}
                    onComplete={() => this.showAdOnAppEvent('advtOnComplete')}
                    onEndBattle={() => this.showAdOnAppEvent('advtOnEndBattle')}
                    onCloseConfirm={(callback?: Function) => this.showAdOnAppEvent('advtOnCloseConfirm', callback)}
                    {...this.props}
                    lang={this.state.lang}
                />
            </>
        )
    }

    async componentDidMount(): Promise<void> {
        YandexWrapper.loadYandexSDK()
        this.initYandexSdk((sdk: any) => {
            this.sdk = sdk

            const lang = sdk.environment && sdk.environment.i18n ? sdk.environment.i18n.lang : 'ru'
            this.setState({lang})
        })
        const {lastShowAdvertTimeInitial} = await getSettings()

        this.lastShowAdvertTime = Date.now() - lastShowAdvertTimeInitial
    }

    private async init(): Promise<void> {
        const {advtInterval} = await getSettings()
        this.lastShowAdvertTime = Date.now() - (advtInterval - 1) * MINUTE
    }

    private static loadYandexSDK(): void {
        let target = document.getElementsByTagName('script')[0]

        if (target && target.parentNode) {
            let script = document.createElement('script')
            script.src =
                process.env.NODE_ENV === 'development'
                    ? 'http://' + window.location.host + '/fake-yandex-sdk.js'
                    : 'https://yandex.ru/games/sdk/v2'
            script.async = true
            target.parentNode.insertBefore(script, target)
        }
    }

    private initYandexSdk(callback: Function): void {
        // @ts-ignore
        if (typeof window['YaGames'] === 'undefined') {
            this.wait(() => {
                this.initYandexSdk(callback)
            })
        } else {
            // @ts-ignore
            window['YaGames']
                .init({
                    screen: {
                        fullscreen: 'ontouchstart' in window,
                    },
                })
                .then((sdk: any) => {
                    callback(sdk)
                })
        }
    }

    private wait(fn: Function): void {
        this.waitTime = Math.min(this.waitTime + 1, 1000)
        setTimeout(() => fn(), this.waitTime)
    }

    private async showAdvert(callback?: Function): Promise<void> {
        if (this.sdk) {
            const {advtInterval, advtLimit, advtDesktopDisable} = await getSettings()
            const isTimeExpired: boolean = Date.now() - this.lastShowAdvertTime > advtInterval * MINUTE

            if (!advtDesktopDisable && isTimeExpired && this.advtCounter < advtLimit) {
                globalMuteSound()
                let showAdvertTime = Date.now()
                this.lastShowAdvertTime = showAdvertTime

                this.sdk.adv.showFullscreenAdv({
                    callbacks: {
                        onClose: (wasShown: any) => {
                            if (wasShown) {
                                this.advtCounter += 1
                            }
                            if (callback) {
                                let time = Math.ceil((showAdvertTime - Date.now()) / 1000)
                                callback(wasShown, time)
                            }
                        },
                    },
                })
            } else {
                if (process.env.NODE_ENV === 'development' && !advtDesktopDisable) {
                    let dt = Date.now() - this.lastShowAdvertTime
                    let t = Math.ceil((advtInterval * MINUTE - dt) / SECOND)
                    console.log(`Реклама через: ${t} sec`)
                }
                if (callback) {
                    callback(false, 0)
                }
            }
        } else {
            if (callback) {
                callback(false, 0)
            }
        }
    }

    private async showAdOnAppEvent(settingsKey: string, callback?: Function): Promise<void> {
        const settings: Settings = await getSettings()
        // @ts-ignore
        if (settings && settings[settingsKey]) {
            await this.showAdvert(callback)
        }
    }
}
